import axios from "axios";

const SHIPINSURE_API_URL = import.meta.env.VITE_SHIPINSURE_API_URL;

export const api = axios.create({
  baseURL: SHIPINSURE_API_URL,
});
